
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/featured-topics/[[...slug]]",
      function () {
        return require("private-next-pages/featured-topics/[[...slug]].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/featured-topics/[[...slug]]"])
      });
    }
  